// recovery-tick-start-scan.ts
//
// Orchestrator recovery (3.40.0, D2.8): at the START of every tick-boundary
// drain (after halt + quota, before ANY directive — N26), finish what a
// previous run left half-done: a stop journaled but never materialized (crash
// after `attempt_finished`), an intent without result, or a chain of `failed`
// tries. Reads the JOURNAL (never the projection), so a skip already written
// is never re-evaluated. Runs before the redirect drain so a redirect cannot
// take the id a pending recovery intent names. Never throws: a failure is
// reported and the next tick tries again.
import type { MissionStore } from "./mission-store.js";
import { materializePendingRecoveries } from "./recovery-ticket-materializer.js";
import type { RecoveryMaterializeContext } from "./recovery-ticket-materializer-types.js";

export type RecoveryScanInput = Omit<RecoveryMaterializeContext, "store"> & { store: MissionStore };

export async function scanPendingRecoveriesAtTickStart(input: RecoveryScanInput): Promise<void> {
  try {
    await materializePendingRecoveries({
      store: input.store,
      controlRoot: input.controlRoot,
      repoDir: input.repoDir,
      gitRunner: input.gitRunner,
      evaluatePolicy: input.evaluatePolicy,
      missionId: input.missionId,
      notify: input.notify,
    });
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    input.notify?.(`Quét gỡ kẹt đầu tick lỗi (${message}) — tick sau quét lại`);
  }
}
